import { useEffect } from "react";
import { toast } from "sonner";

export const UpdateNotice = () => {
  useEffect(() => {
    const onUpdate = (e) => {
      const reg = e.detail;
      toast("🌱 Nova versão disponível", {
        id: "pwa-update",
        description: "Atualize para usar a versão mais recente do HeveaTalent.",
        duration: Infinity,
        action: {
          label: "Atualizar",
          onClick: () => {
            if (reg && reg.waiting) {
              reg.waiting.postMessage({ type: "SKIP_WAITING" });
            } else {
              window.location.reload();
            }
          },
        },
      });
    };
    window.addEventListener("pwa-update-available", onUpdate);
    return () => window.removeEventListener("pwa-update-available", onUpdate);
  }, []);

  return null;
};

export default UpdateNotice;
